import { Inject, Injectable, Injector } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { Observable } from 'rxjs';
import { RouteInterceptor } from '../../../models/common';

@Injectable()
export class InterceptorGuard implements CanActivate {
    constructor(private _injector: Injector, @Inject(SETTINGS) private _settings: ISettings) {}

    public canActivate(routeSnapshot: ActivatedRouteSnapshot): Observable<boolean> {
        const interceptor: RouteInterceptor = routeSnapshot.data && routeSnapshot.data.interceptor;

        if (typeof interceptor !== 'function') {
            throw new Error(
                `The value passed to 'Route#data.interceptor' must be of type 'function'; ` +
                    `received ${interceptor}`
            );
        }

        // Note: If any other parameters are needed in the interceptor, just pass in the Injector.
        return interceptor(routeSnapshot, this._injector, this._settings);
    }
}
